import React from "react";
import { Button, Container } from "react-bootstrap";
import Banner from "../components/Banner";
import BreadcrumbBar from "../components/Breadcrumb";

export default function Notifications() {
  return (
    <>
      <Banner
        heading="Notifications"
        description="Stay updated with the latest notifications related to your account and activities."
      />
      <BreadcrumbBar
        items={[{ label: "Home", href: "/" }, { label: "Notifications" }]}
      />
      <Container>
        <div className="profile-outer-box">
          <div className="profile-content">
            <div className="notifications">
              <div className="notification-item active">
                <div className="notification-time">Today, 2025 - 10:36 AM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    Subscription Updated Successfully
                  </div>
                  <p>
                    Your Insight Plus plan is now active. Enjoy premium features
                    right away.
                  </p>
                </div>
              </div>
              <div className="notification-item">
                <div className="notification-time">Today, 2025 - 03:45 PM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    New Reply in Your Discussion
                  </div>
                  <p>
                    Sarah responded to “Lifestyle Habits That Reduce Risk of
                    Heart Disease.”
                  </p>
                </div>
              </div>
              <div className="notification-item">
                <div className="notification-time">Today, 2025 - 10:36 AM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    Subscription Updated Successfully
                  </div>
                  <p>
                    Your Insight Plus plan is now active. Enjoy premium features
                    right away.
                  </p>
                </div>
              </div>
              <div className="notification-item failed">
                <div className="notification-time">Today, 2025 - 03:45 PM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    New Reply in Your Discussion
                  </div>
                  <p>
                    Sarah responded to “Lifestyle Habits That Reduce Risk of
                    Heart Disease.”
                  </p>
                </div>
              </div>
              <div className="notification-item">
                <div className="notification-time">Today, 2025 - 10:36 AM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    Subscription Updated Successfully
                  </div>
                  <p>
                    Your Insight Plus plan is now active. Enjoy premium features
                    right away.
                  </p>
                </div>
              </div>
              <div className="notification-item">
                <div className="notification-time">Today, 2025 - 03:45 PM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    New Reply in Your Discussion
                  </div>
                  <p>
                    Sarah responded to “Lifestyle Habits That Reduce Risk of
                    Heart Disease.”
                  </p>
                </div>
              </div>
              <div className="notification-item">
                <div className="notification-time">Today, 2025 - 10:36 AM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    Subscription Updated Successfully
                  </div>
                  <p>
                    Your Insight Plus plan is now active. Enjoy premium features
                    right away.
                  </p>
                </div>
              </div>
              <div className="notification-item worning">
                <div className="notification-time">Today, 2025 - 03:45 PM</div>
                <div className="notification-content">
                  <div className="notification-title">
                    New Reply in Your Discussion
                  </div>
                  <p>
                    Sarah responded to “Lifestyle Habits That Reduce Risk of
                    Heart Disease.”
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
